export default __webpack_public_path__ + "static/media/excel_icon.e1fecacf.svg";